// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"SideDrawer__SideDrawer__3wvlM","SideMenu":"SideDrawer__SideMenu__3lTTj","Logo":"SideDrawer__Logo__10IHv","Open":"SideDrawer__Open__3xsf8","Close":"SideDrawer__Close__2S6c7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDrawer/SideDrawer.css
// module id = 453
// module chunks = 0